export const CURRENCIES = {
  USD: {
    units: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
    unitsAndSubUnits: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  GBP: {
    units: {
      symbol: '£',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
    unitsAndSubUnits: {
      symbol: '£',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  CAD: {
    units: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: ' CAD',
    },
    unitsAndSubUnits: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: ' CAD',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  AUD: {
    units: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: ' AUD',
    },
    unitsAndSubUnits: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: ' AUD',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  NZD: {
    units: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: ' NZD',
    },
    unitsAndSubUnits: {
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: ' NZD',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  EUR: {
    units: {
      symbol: '€',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
    unitsAndSubUnits: {
      symbol: '€',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
    analytics: {
      symbol: '',
      decimal: '.',
      thousand: '',
      precision: 2,
      format: '%s%v',
      suffix: '',
    },
  },
  JPY: {
    units: {
      symbol: '¥',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
    unitsAndSubUnits: {
      symbol: '¥',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
    analytics: {
      symbol: '',
      thousand: '',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
  },
  KRW: {
    units: {
      symbol: '',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '원',
    },
    unitsAndSubUnits: {
      symbol: '',
      thousand: ',',
      precision: 0,
      format: '%s%v',
      suffix: '원',
    },
    analytics: {
      symbol: '',
      thousand: '',
      precision: 0,
      format: '%s%v',
      suffix: '',
    },
  },
};
